import { useLazyQuery } from '@apollo/client';
import { Sidebar } from '@insurancemenu/imenu-components-lib';
import { GET_USER_OR_PRODUCER_BY_ID } from 'api/queries/userService';
import AdditionalAccess from 'components/common/group/sidebar/AdditionalAccess';
import ContactInfo from 'components/common/group/sidebar/ContactInfo';
import Notes from 'components/common/group/sidebar/Notes';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import { FullUser, Producer } from 'types/userService';
import { Group } from 'types/groupService';
import ContactBlock from 'components/common/group/sidebar/ContactBlock';
import { createStyles } from './styles';

function getAorName(user: FullUser | Producer, type: 'user' | 'producer'): string {
  if (type === 'user') {
    const userUser = user as FullUser;
    return `${userUser.firstName} ${userUser.middleName || ''} ${userUser.lastName}`;
  }
  const producerUser = user as Producer;
  return producerUser?.name || '';
}

interface Props {
  group: Group;
}

const EmployerSidebar: React.FC<Props> = observer(({ group }) => {
  const {
    userStore: { isLoading },
    domainStoreV2: { domainHeader },
  } = useRootStore();

  const { agentOfRecord } = group;

  const [getUserByIdQuery, { data }] = useLazyQuery<{
    userByIdOrNull: FullUser;
    getProducerOrNull: Producer;
  }>(GET_USER_OR_PRODUCER_BY_ID, {
    fetchPolicy: 'no-cache',
    variables: {
      userId: agentOfRecord?.id,
      id: agentOfRecord?.id,
    },
  });

  const userUser = data?.userByIdOrNull as FullUser | null;
  const producerUser = data?.getProducerOrNull as Producer | null;

  useEffect(() => {
    if (agentOfRecord?.id) {
      void getUserByIdQuery();
    }
  }, [getUserByIdQuery, agentOfRecord?.id]);

  const classes = createStyles();

  const aorName = getAorName((userUser || producerUser)!, userUser ? 'user' : 'producer');

  return (
    <Sidebar className={classes.sidebar}>
      {!isLoading && group.id && (
        <>
          <ContactInfo />
          <AdditionalAccess groupId={group.id} editableType="NONE" />
          {group.agentOfRecord && (
            <ContactBlock
              blockTitle={domainHeader.id === '123' ? 'Carrier Contact Information' : 'Agent Information'}
              info={{
                name: aorName,
                phone:
                  userUser?.telephone ||
                  producerUser?.sponsorSpecificData.phone ||
                  producerUser?.sponsorSpecificData.telephone ||
                  '',
                email: userUser?.email || producerUser?.sponsorSpecificData?.email || '',
              }}
            />
          )}
          <Notes employerGroupId={group.id} />
        </>
      )}
    </Sidebar>
  );
});

export default EmployerSidebar;
